let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2W0AX")).then(() => parcelRequire('fbvi5'));